<template>
    <div>
        <!--    导航栏-->
<!--        <Anav></Anav>-->
        <van-nav-bar id="reset" fixed :title="$route.name"
                     style="background-color: rgba(6,193,174,1);height: 3rem" :aria-label="$route.name">
        </van-nav-bar>
        <!--    标签栏-->
        <Atablebar></Atablebar>
        <div class="box"></div>

        <div v-for="(item,index) in list" :key="index" style="margin-top: 18px;" @click="jump(item.userBuyId)" role="button" :aria-labelledby="['baodai' + index + ' ' +'baodaiN' + index]">
            <div class="title">
                <div style="height:26px"></div>
                <span class="title-item"><span :id="['baodai' + index]" aria-hidden="true">{{item.prodName}}</span> </span>
                <div style="height:20px"></div>
            </div>
            <div class="title">
                <div class="content" :id="['baodaiN' + index]" aria-hidden="true">
                    <p>保障状态：{{getstates(item.states)}}</p>
                    <p>保障生效日期：{{item.effectiveDate}}</p>
                    <p>保障到期日期：{{item.deadline}}</p>
                </div>
            </div>
        </div>
        <div style="height: 3.2rem "></div>

    </div>

</template>

<script>

    import Vue from 'vue';
    import {Field, Button, Notify} from 'vant';
    //引入组件
    import Anav from './Acomponent/Anav';
    import Atablebar from './Acomponent/Atablebar';
    Vue.use(Field).use(Button).use(Notify);


    export default {
        components:{
            // Anav,
            Atablebar,
        },
        name: "Scroll",
        data() {
            return {
                list: [],
                active: 0,

                type: 0,
                // pageSize: 10,
                // 四种状态页码
                states1: 1,
                states2: 1,
                states3: 1,
                states4: 1,
            }
        },
        props: {
            name: {},
        },
        created:function(){

            setTimeout(this.getList(1),100)
            setTimeout(this.getList(2),200)
            setTimeout(this.getList(3),300)
            setTimeout(this.getList(4),400)
            // this.getList(1)
            // this.getList(2)
            // this.getList(3)
            // this.getList(4)
        },
        // mounted(){
        //     window.addEventListener('scroll', this.scrollEvent,false);
        // },
        // destroyed () {
        //     window.removeEventListener('scroll', this.scrollEvent, false);
        // },
        methods: {
            // 触底事件
            // scrollEvent(){
            //     if (document.documentElement.scrollTop
            //         + document.documentElement.clientHeight
            //         >= document.body.scrollHeight) {
            //         console.log("aaaa")
            //         // if(){
            //         //
            //         // }
            //
            //     }
            // },






            getList(states){
                this.$axios.get("/order/alist", {
                    params: {
                        states: states,
                        page: 0,
                        pageSize: this.pageSize,
                        type: this.type
                    }
                }).then(res => {
                    this.list = this.list.concat(res.data.rows)
                });
            },

            getstates(states){
                switch (states) {
                    case "1":
                        return '待支付'
                    case "2":
                        return '待生效'
                    case "3":
                        return '保障中'
                    case "4":
                        return '已失效'
                }
            },


            jump(userBuyId){
                window.location.href = 'ApolicyDetails?type=0&userBuyId='+userBuyId
                console.log(this.$route.type)
            },


        }
    }
</script>

<style scoped>
    #reset /deep/ .van-ellipsis{
        color: #fff !important;
        font-size:1.2rem;
        font-weight:500;
    }
    .box{
        height: 3rem;
    }
    .title{
        background-color:#fff;
        /*width: 100%;*/
        margin-top: 1px;
        border: 1px solid #fff;
    }
    .title .title-item{
        color:#fff;
        line-height: 50px;
        font-size: 1.2rem;
        background-color: rgb(6, 193, 174);
        font-weight: bold;
        padding: 10px 34px 10px 12px;
        border-bottom-right-radius: 25px;
        border-top-right-radius: 25px;
    }
    .content{
        font-size: 1rem;
        margin-left: 12px;
        color: rgb(73, 110, 232);
        font-weight: 500;
        padding-bottom: 10px;
    }

</style>
